<div class="action-arrow__content">
	<cv-dropdown-button
		[label]="'Select a Log'"
		[icon]="'fa-book'"
		[position]="'down'"
		[buttonClass]="'btn-sm cv-btn-light'"
		[items]="logDropdownItems"
		(menuOpened)="onSelectListOpen()"
		(menuClosed)="onSelectListClose()"
		(subOptionClick)="onViewLog($event)"
	>
	</cv-dropdown-button>
</div>
